module.exports = __webpack_public_path__ + "img/lk.2eb97db9.svg";